import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FragnoToggle, FragnoCheckbox } from 'fragno/react';
import style from '../../../style/components/profile/preferences/WalletEmailSubscriptions.module.scss';

const WalletEmailSubscriptions = ({
  subscriptions,
  isFetching,
  onToggleAll,
  onToggleSubscription,
}) => {
  const { t } = useTranslation();

  if (!subscriptions || subscriptions.length === 0) {
    return null;
  }

  const allChecked = subscriptions.every((sub) => sub.active);

  // Master toggle is redundant when there's only one subscription —
  // the single checkbox already controls everything. Hide it.
  const showMasterToggle = subscriptions.length > 1;

  return (
    <div className={style.container}>
      <div className={style.headerRow}>
        <h4 className={style.title}>
          {t('walletPreferences.emailSubscriptions')}
        </h4>
        {showMasterToggle && (
          <FragnoToggle
            size="sm"
            checked={allChecked}
            onChange={onToggleAll}
            disabled={isFetching}
            aria-label={t('walletPreferences.toggleAllAriaLabel')}
          />
        )}
      </div>
      <ul className={style.subscriptionList}>
        {/* API does not provide an `id` field; subscription `name` is the stable unique key per the backend contract. */}
        {subscriptions.map((subscription, index) => (
          <li key={subscription.name} className={style.subscriptionItem}>
            <FragnoCheckbox
              checked={subscription.active}
              onChange={() => onToggleSubscription(index)}
              label={subscription.name}
              labelSubtext={subscription.description}
              disabled={isFetching}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

WalletEmailSubscriptions.propTypes = {
  subscriptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      active: PropTypes.bool.isRequired,
    }),
  ).isRequired,
  isFetching: PropTypes.bool.isRequired,
  onToggleAll: PropTypes.func.isRequired,
  onToggleSubscription: PropTypes.func.isRequired,
};

export default memo(WalletEmailSubscriptions);
